import i18n from '@/plugins/i18n'

export const colors = [
  '#D13D4B',
  '#DD644C',
  '#EB8547',
  '#F4A641',
  '#FFC73C',
  '#F9E03B',
  '#F9E03B',
  '#BBD665',
  '#9FD17C',
  '#86CC8E'
]

function getColorForValue(value: number, max: number, reverse = false, colorRange: string[] = colors) {
  let percentage = value / max

  if (percentage > 1) percentage = 1

  let index = Math.floor(percentage * 10)

  if (index === 0) index = 1

  if (reverse) {
    return colorRange[colorRange.length - index]
  }

  return colorRange[index - 1]
}

interface ColorValueDefinition {
  max: number,
  color: string
}

function getColorForValueWithDefinition(value: number, definition: ColorValueDefinition[]) {
  if (!value) value = 0

  return definition.find(({ max }) => value <= max)?.color
}

function processMaxValues(stats: any[], factor: number = 1.3) {
  if (!stats) return {}

  const maxValues: any = {}

  for (const stat of stats) {
    if (!stat) continue

    const keys = Object.keys(stat)

    for (const key of keys) {
      maxValues[key] = (!maxValues[key] || stat[key] * factor > maxValues[key]) ? stat[key] * factor : maxValues[key]
    }
  }

  return maxValues
}

function processMinValues(stats: any[]) {
  if (!stats) return {}

  const minValues: any = {}

  for (const stat of stats) {
    if (!stat) continue

    const keys = Object.keys(stat)

    for (const key of keys) {
      minValues[key] = (!minValues[key] || stat[key] < minValues[key]) ? stat[key] : minValues[key]
    }
  }

  return minValues
}

function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min) + min)
}

function toCamelCase(str: string) {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase())
}

function getOrdinal(num: number) {
  if (num % 100 >= 11 && num % 100 <= 13) {
    return i18n.t('ordinal.1', { num: num })
  }

  switch (num % 10) {
    case 1:
      return i18n.t('ordinal.1', { num: num })
    case 2:
      return i18n.t('ordinal.2', { num: num })
    case 3:
      return i18n.t('ordinal.3', { num: num })
    default:
      return i18n.t('ordinal.other', { num: num })
  }
}

export { getColorForValue, processMaxValues, processMinValues, getRandomInt, getColorForValueWithDefinition, toCamelCase, getOrdinal, ColorValueDefinition }
